"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var offer_1 = require("@baemingo/offer");
var offer_matcher_1 = require("../offer-matcher");
exports.default = {
    add: function (items, itemToAdd) {
        return __spread(items, [
            __assign(__assign({}, itemToAdd), { offerId: null, offerTitle: null, stageId: null, defaultDiscount: itemToAdd.discount }),
        ]);
    },
    // Remove an item from our cart
    remove: function (items, id) {
        return items.filter(function (item) { return item.id !== id; });
    },
    // Get the sum of all items in the cart
    sum: function (items) {
        return items.reduce(function (sum, item) { return sum + item.amount - item.discount; }, 0);
    },
    sumDiscounts: function (items) {
        return items.reduce(function (sum, item) { return sum + item.discount; }, 0);
    },
    subtotalSum: function (items) {
        var subtotal = items.reduce(function (sum, item) {
            var amount = item.amount - item.discount;
            var subtotal = amount / (1 + item.vatRate / 100);
            return sum + subtotal;
        }, 0);
        return Math.round(subtotal);
    },
    vatSum: function (items) {
        var vat = items.reduce(function (sum, item) {
            var amount = item.amount - item.discount;
            var subtotal = amount / (1 + item.vatRate / 100);
            var vat = amount - subtotal;
            return sum + vat;
        }, 0);
        return Math.round(vat);
    },
    /*
     * Recalculate Discounts
     *
     * Applies either an order discount or the user's membership discount,
     * based on whats configured for the cart.
     *
     * Returns an array of updated items
     */
    recalculateDiscounts: function (items, availableItemOffers, orderOffer, promoCode, membershipDiscount) {
        var availableOffers = promoCode ? [] : availableItemOffers;
        /**
         * Bundle and/or staged offer handling
         */
        // Find offers that match with the items we have in cart
        var offerMatchResult = offer_matcher_1.default(items, availableOffers.map(function (o) { return ({
            id: o.id,
            title: o.title,
            items: o.itemIds.map(function (id) { return ({ id: id }); }),
            stages: o.stages.map(function (stage) { return ({
                id: stage.id,
                items: stage.itemIds.map(function (id) { return ({ id: id }); }),
            }); }),
            type: o.offerType,
        }); }));
        // Keep track of which stage we are at, per offer
        var stageCount = {};
        // For all matches, iterate and calculate discount
        var offerItems = offerMatchResult.matches.reduce(function (arr, match) {
            // Get the offer metadata from our available offers
            var availableOffer = availableOffers.find(function (o) { return o.id === match.offerId; });
            // Configure an Offer instance we will use to calc price
            var offer = new offer_1.default();
            offer.setType(availableOffer.offerType);
            offer.setDiscountType(availableOffer.discountType);
            offer.setRate(availableOffer.discountRate);
            var itemStageMap = {};
            // Add all items for this offer to the offer
            match.items.forEach(function (_a) {
                var _b;
                var _c;
                var id = _a.id;
                var item = items.find(function (i) { return i.id === id; });
                var entry = {
                    disableMembershipDiscount: item.disableMembershipDiscounts,
                    id: item.id,
                    price: item.amount,
                    vatRate: item.vatRate,
                };
                if (availableOffer.stages.length > 0) {
                    // Set the stage count to zero if its not already set
                    (_b = stageCount[_c = availableOffer.id]) !== null && _b !== void 0 ? _b : (stageCount[_c] = 0);
                    // Get the stage, based on the stage count for this offer
                    var stage = availableOffer.stages[stageCount[availableOffer.id]];
                    // Increment the stage count
                    stageCount[availableOffer.id]++;
                    itemStageMap[id] = stage.id;
                    offer.addStage({
                        entry: {
                            disableMembershipDiscount: item.disableMembershipDiscounts,
                            id: item.id,
                            price: item.amount,
                            vatRate: item.vatRate,
                        },
                        price: entry.price,
                        rate: stage.discountRate,
                        type: stage.discountType,
                    });
                }
                else {
                    offer.addEntry(entry);
                }
            });
            // Calculate the discounted value
            var discounted = offer.getDiscounted();
            // For all (now discounted) items, add them
            // to our array of items that we return in the end
            discounted.forEach(function (discountItem) {
                var item = items.find(function (i) { return i.id === discountItem.id; });
                arr.push(__assign(__assign({}, item), { discount: item.amount - discountItem.discountedPrice, offerId: availableOffer.id, offerTitle: availableOffer.title, stageId: itemStageMap[item.id] }));
            });
            return arr;
        }, []);
        /**
         * Membership discount handling
         *
         * We take all items that did not match the offers we have
         * in cart and apply the order offer / membership
         * discount to them.
         */
        var offer = new offer_1.default();
        offer.setType('ORDER_DISCOUNT');
        if (orderOffer) {
            offer.setDiscountType(orderOffer.discountType);
            offer.setRate(orderOffer.discountRate);
            offer.setIsMembershipDiscount(false);
        }
        else if (promoCode) {
            offer.setDiscountType(promoCode.discountType);
            offer.setRate(promoCode.discountRate);
            offer.setIsMembershipDiscount(false);
        }
        else {
            offer.setIsMembershipDiscount(true);
            offer.setRate(membershipDiscount);
            offer.setDiscountType('PERCENTAGE');
        }
        // If we are using promo codes AND category filtering, 
        // this array will contain items that are outside of the category filter
        var undiscountedItems = [];
        offerMatchResult.unmatched.forEach(function (unmatchedItem) {
            var _a;
            var item = items.find(function (i) { return i.id === unmatchedItem.id; });
            // This is true if we are using promo code filtering.
            if ((_a = promoCode === null || promoCode === void 0 ? void 0 : promoCode.categoryIds) === null || _a === void 0 ? void 0 : _a.length) {
                // If item is not part of category filter, add to undiscounted items and continue
                var isIncluded = promoCode.categoryIds.includes(item.categoryId);
                if (!isIncluded) {
                    undiscountedItems.push(item);
                    return;
                }
            }
            offer.addEntry({
                disableMembershipDiscount: item.disableMembershipDiscounts,
                id: item.id,
                price: item.amount,
                vatRate: item.vatRate,
            });
        });
        var result = offer.getDiscounted();
        var unmatched = result.map(function (discountedItem) {
            var item = items.find(function (i) { return i.id === discountedItem.id; });
            var newDiscount = item.amount - discountedItem.discountedPrice;
            return __assign(__assign({}, item), { discount: Math.max(item.defaultDiscount, newDiscount) });
        });
        // Return both items with offers and items without offers
        return offerItems.concat(unmatched).concat(undiscountedItems);
    }
};
